
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/packs/userFrontend/features/publication/components/WorkStatusLabel/styles.css.ts.vanilla.css\",\"source\":\"Ll8xeTF5emFiMSB7CiAgZGlzcGxheTogaW5saW5lLWZsZXg7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsKICBwYWRkaW5nOiA1cHggOHB4Owp9Ci5fMXkxeXphYjIgewogIGJhY2tncm91bmQtY29sb3I6ICNlYjcxNGM7Cn0KLl8xeTF5emFiMyB7CiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmNzg3ODsKfQouXzF5MXl6YWI0IHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWJkYzRkOwp9Ci5fMXkxeXphYjUgewogIGJhY2tncm91bmQtY29sb3I6ICNmZjRjNGM7Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/packs/userFrontend/features/publication/components/WorkStatusLabel/styles.css.ts.vanilla.css\",\"source\":\"Ll8xeTF5emFiMSB7CiAgZGlzcGxheTogaW5saW5lLWZsZXg7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsKICBwYWRkaW5nOiA1cHggOHB4Owp9Ci5fMXkxeXphYjIgewogIGJhY2tncm91bmQtY29sb3I6ICNlYjcxNGM7Cn0KLl8xeTF5emFiMyB7CiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmNzg3ODsKfQouXzF5MXl6YWI0IHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjZWJkYzRkOwp9Ci5fMXkxeXphYjUgewogIGJhY2tncm91bmQtY29sb3I6ICNmZjRjNGM7Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
